<template>
  <div>
    <h1 class="text-lg font-bold">Entendiendo tus bases de Conocimientos</h1>
    <div class="text-neutral-700 mt-5 space-y-4">
      <p>
        Antes de comenzar con las lecciones, es importante para nuestros estudiantes realizar un examen diagnóstico, de esta manera podemos identificar tu nivel actual de conocimientos, personalizar el contenido y maximizar tu aprendizaje.
      </p>
    </div>

    <router-link :to="examId" class="nav-link mt" v-if="examId">
      <button class="mob-btn mob-cta-gold-outline mt-2" >
        ¡Entendido!
      </button>
    </router-link>


  </div>
</template>

<script>
export default {
  name: "ExamIntro",

  data() {
    return {
      examId: null
    };
  },
  mounted() {

    let course = this.$store.state.course.current;
    if (!course) {
      this.$router.push("/introduction")
    } else {
      if (course.examDiag) {
        this.examId = "" + course.examDiag.id;
      }
    }
  },
};
</script>
